export default {
  init() {
    // JavaScript to be fired on all pages
    function checkScroll() {
        var startY = $('.navbar').height() / 2; //The point where the navbar changes in px
        if ($(window).scrollTop() > startY){
            $('body').addClass('b-scrolled');
            //$('.navbar').addClass('scrolled bg-trans py-2');
            //$('.navbar').removeClass('py-4');
            //$('.logo').css('width', 100);
        } else {
            $('body').removeClass('b-scrolled');
            //$('.navbar').removeClass('scrolled bg-trans py-2');
            //$('.navbar').addClass('py-4');
            //$('.logo').css('width', 140);
            //$('.animated').removeClass('animated');
            //$('.fadeInUp').removeClass('fadeInUp');
            //$('.fadeInDown').removeClass('fadeInDown');
            //$('.fadeIn').removeClass('fadeIn');
        }
    }

    $('[data-toggle="popover"]').popover();

    if($('.navbar').length > 0){
      $(window).on('scroll load resize', function() {
        if(!$('body').hasClass('b-nav-open')) {
            checkScroll();
        }
      });
    }

    $('section').waypoint(function() {
        if($(this.element).attr('id')) {
          var section = $(this.element).attr('id');
          $('.wrap #' + section + ' h2').addClass('animated fadeInDown');
          $('.wrap #' + section + ' h3').addClass('animated fadeInDown');
          $('.wrap #' + section + ' h4').addClass('animated fadeInLeft');
          $('.wrap #' + section + ' h5').addClass('animated fadeInUp');
          $('.wrap #' + section + ' p').addClass('animated fadeInUp');
          $('.wrap #' + section + ' ul').addClass('animated fadeInDown');
          $('#' + section + ' .image-1').addClass('animated fadeIn');
          $('#' + section + ' .image-2').addClass('animated fadeIn');
          $('#' + section + ' .card-img-top-holder').addClass('animated fadeIn');
        }

        }, {
            offset: '65%',
    });

    $('.display-3').lettering('words');

     /* slider function */
     $('#logo-carousel').slick({
      autoplay: true,
      arrows: false,
      speed: 300,
      dots: false,
      infinite: true,
      slidesToShow: 5, 
      slidesToScroll: 1,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
  })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js